'use strict';

module.exports.default = {
    "MS_SOCO_PUBLIC_API_URL": "https://api.soco.id",
    "MS_BJ_PUBLIC_API_URL": "https://bj-public-api.soco.id",
    "MS_CATALOG_API_URL": "https://catalog-api.soco.id",
    "MS_POS_API_URL": "https://pos-api.soco.id",
    "MS_ANALYTICS_API_URL": "https://analytics-api.soco.id",
    "SOCO_WEB_URL": "https://www.soco.id",
    "BJ_WEB_URL": "https://www.beautyjournal.id",
    "REVIEW_WEB_URL": "https://review.soco.id",
    "SOCIOLLA_WEB_URL": "https://www.sociolla.com",
    "MS_ORDER_API_URL": "https://orders-api.sociolla.com/",
    "LULLA_WEB_URL": "https://www.lilla.id",
    "MS_ACCOUNTS_API_URL": "https://accounts-api.soco.id",
    "MS_REVIEW_API_URL": "https://review-api.soco.id",
    "CENTRAL_LOGIN_WEB_URL": "https://login.soco.id",
    "RECAPTCHA_SITE_KEY": "6LdGhu0UAAAAAHRDh2bM97TEDB9UMBZSLjtsKe4F",
    "FB_APP_ID": "1030272380362840",
    "GOOGLE_CLIENT_ID": "266385423655-27dbsmtn7keg2tov39m2easdbd0gb8hv.apps.googleusercontent.com",
    "MS_SOCO_PUBLIC_API_LIST": [
        "https://api.soco.id"
    ],
    "MS_BJ_PUBLIC_API_LIST": [
        "https://bj-public-api.soco.id"
    ],
    "MS_CATALOG_API_LIST": [
        "https://catalog-api.soco.id"
    ],
    "MS_CART_API_LIST": [
        "https://carts-api.soco.id"
    ]
};
